// a quick jQuery Select tool
// adapted from  bling.js

const select = document.querySelectorAll.bind(document);

Node.prototype.on = window.on = function(name, fn) {
	this.addEventListener(name, fn);
	return this;
};

NodeList.prototype.addClass = function(className) {
	this.forEach(function(el) {
		el.classList.add(className);
	});
	return this;
};

NodeList.prototype.removeClass = function(className) {
	this.forEach(function(el) {
		el.classList.remove(className);
	});
	return this;
};


NodeList.prototype.__proto__ = Array.prototype;

NodeList.prototype.on = NodeList.prototype.addEventListener = function(name, fn) {
	this.forEach(function(el) {
		el.on(name, fn);
	});
	return this;
};

module.exports = select;


// WEBPACK FOOTER //
// ./lib/select.js